import { BaseDetail } from 'App/Component/Bases'
import fields from 'App/Screens/Job/JobTypes/fields'

class PageAdd extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = 'Job Type'
    this.urlData = 'module-job-jobType'
    this.fields = fields
    this.state = {
      isCheckingPermission: false,
      isAccessAllowed: true
    }
  }
}

export default PageAdd